var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5002 15.5C12.2442 15.5 11.9883 15.402 11.7933 15.207L7.79325 11.207C7.40225 10.816 7.40225 10.184 7.79325 9.79301C8.18425 9.40201 8.81625 9.40201 9.20725 9.79301L12.5122 13.098L15.8053 9.91801C16.2043 9.53501 16.8352 9.54601 17.2192 9.94301C17.6032 10.34 17.5922 10.974 17.1952 11.357L13.1953 15.219C13.0002 15.407 12.7502 15.5 12.5002 15.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/ArrowDown.875ce32d652856ebe47a78532f048e5b.svg";
export { ForwardRef as ReactComponent };